<template>
  <div>
    <div
      v-if="action"
      @mouseover="onOver"
      @mouseleave="onLeave"
    >
      <b-dropdown
        ref="dropdown"
        variant="link"
        toggle-class="p-0 border-0"
        no-caret
        menu-class="mt-0"
      >
        <template #button-content>
          <div
            class="m-show-image"
          >
            <div
              v-if="isMain"
              class="badge badge-primary s-10 position-absolute position-right-0 position-top-0 m-25 p-25"
            >
              Utama
            </div>
            <b-badge
              v-if="type.includes('video')"
              class="m-show-image__badge-type"
              variant="primary"
            >
              Video
            </b-badge>
            <span class="m-show-image__wrapper">
              <img
                v-if="type.includes('image')"
                :src="linkStaging(`${src}`, 300, 300)"
                alt="icon"
                class="m-show-image__preview"
              >

              <video
                v-if="type.includes('video')"
                id="video-preview"
                :src="src"
                class="video-preview"
                width="100%"
                height="100%"
              >
                <source
                  :src="src"
                  type="video/mp4"
                >
              </video>
            </span>
          </div>
        </template>
        <b-dropdown-item
          v-if="setMain && index !== 0"
          @click="$emit('setmain', index)"
        >
          <feather-icon icon="StarIcon" />
          <span class="align-middle ml-50">Jadikan Gambar Utama</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="type.includes('video') ? showVideo(src, previewTitle) : showImage(linkReplaceStaging(src), previewTitle)"
        >
          <feather-icon icon="EyeIcon" />
          <span class="align-middle ml-50">Lihat</span>
        </b-dropdown-item>
        <b-dropdown-item
          @click="$emit('delete', index)"
        >
          <feather-icon icon="TrashIcon" />
          <span class="align-middle ml-50">Hapus</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div v-else>
      <div
        class="m-show-image"
        @click="showImage(linkReplaceStaging(src), previewTitle)"
      >
        <span class="m-show-image__wrapper">
          <img
            v-if="type.includes('image')"
            :src="linkStaging(`${src}`, 300, 300)"
            alt="icon"
            class="m-show-image__preview"
          >

          <video
            v-if="type.includes('video')"
            id="video-preview"
            :src="src"
            class="video-preview"
            width="100%"
            height="100%"
          >
            <source
              :src="src"
              type="video/mp4"
            >
          </video>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import {
  BDropdown,
  BDropdownItem,
  BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BBadge,
    BDropdown,
    BDropdownItem,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    setMain: {
      type: Boolean,
      default: true,
    },
    isMain: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Boolean,
      default: true,
    },
    previewTitle: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'image',
    },
  },
  methods: {
    onOver() {
      if (this.$store.state.auth.userData.role === 'admin') {
        this.$refs.dropdown.visible = true
      }
    },
    onLeave() {
      if (this.$store.state.auth.userData.role === 'admin') {
        this.$refs.dropdown.visible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.m-show-image {
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  height: 104px;
  text-align: center;
  vertical-align: top;
  width: 104px;
  overflow: hidden;
  position: relative;
  &__wrapper {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    text-align: center;
  }
  &__preview {
      width: 100%;
      height: 100%;
      object-fit: contain;
  }
  &__badge-type {
      position: absolute !important;
      left: 0;
      margin: 0.3rem;
  }
}
</style>
